// React
import React, { Component } from "react";
import Transition from 'react-transition-group/Transition';
import Numeral from 'numeral';

// Stores
import { PricingStore, CurrencyStore, ChartStore } from '../../Stores';

// Styles
import "./charts.css";
import "./chartdetails.css";
import "../../assets/css/animations.css";

// Utils
import { GoogleAnalytics } from '../../Utils';

// Libraries

/**********************************************************
 *    ChartDetails Component
 * 
 *  - 
 *  - 
 **********************************************************/

class ChartDetails extends Component {

    /**********************************************************
     *  Constructor
     **********************************************************/

    constructor(props) {

        super(props);

        this.state = {
            price : 0.00,
            change : '0.00',
            fav : 'icon-heart6 text-pink icon-button',
            emitter : null,
            emitterToken : null,
            show : true,
            overlays : {
                "EMA 20" : false,
                "EMA 50" : false,
                "Bollinger" : false
            }
        }

        this.favouriteChart = this.favouriteChart.bind(this);
    }

/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render, retrieve last known price for topic
    // and listen with emitter for updates
    componentDidMount() {

        //console.log('ChartDetails.componentDidMount()');

        this.setup(null);

    }

    // Determines whether or not component should update
    shouldComponentUpdate(nextProps, nextState) {
        
        if(nextProps.topic !== this.props.topic || nextState.price !== this.state.price
            || nextProps.fav !== this.state.fav)
            return true;
        else
            return false;

    }


    // When chart details updates, check if new topic exists
    // if so, remove old emitter and setup new emitter
    componentDidUpdate(prevProps, prevState) {

        //console.log('ChartDetails.componentDidUpdate()');

        // new topic
        if(this.props.topic !== prevProps.topic) {

            if(this.state.emitterToken !== null){

                console.log('Updating Emitter...');

                this.state.emitterToken.remove();

                this.setup(this.state.emitter);

            }

        }
       
    }


    // Remove the emitter listener
    componentWillUnmount() {

        if(this.state.emitterToken !== null)
            this.state.emitterToken.remove();

    }

/**********************************************************
 *  Functions
 **********************************************************/

    // If given an existing emitter, get initial price, generate token and 
    // start listening for updates
    setup(emitter) {
        
        this.getInitialPrice(this.props.topic)
            .then( (priceObj) => {

                if(emitter === null) {

                    if(this.state.emitterToken != null)
                        emitter = PricingStore.getEmitter([this.state.emitterToken]);
                    else
                        emitter = PricingStore.getEmitter([]);
                } 
                    

                const emitterToken = this.streamPriceUpdates(emitter, this.props.topic);

                this.setState((prev, props) => {
                    return {
                        price : priceObj.price,
                        change : priceObj.change,
                        emitter : emitter,
                        emitterToken : emitterToken,
                        show : !this.state.show
                    }
                });

            })
            .catch( (error) => {
                console.log(error); // todo: display error nicely
            });

    }


    // Return the last price for a given topic
    getInitialPrice(topic) {

        //console.log('ChartDetails.getInitialPrice()');

        return PricingStore.getPrice(topic);

    }


    // Listen for price updates for topic with emitter
    streamPriceUpdates(emitter, topic) {
        
        //console.log('ChartDetails.streamPriceUpdates()');

        const _this = this;

        var emitterToken = emitter.addListener(topic, function(newPriceObj) {

            if(newPriceObj.id === topic) {

                _this.setState((prev, props) => {
                    return {
                        price: newPriceObj.price,
                        change: newPriceObj.change,
                        show : !_this.state.show
                    }
                });

            }
            else {
                console.log('outdated emitter listener has been caught.');
            }

        });

        return emitterToken;

    }


    // Favourite a chart
    favouriteChart() {
    
        //console.log('Charts.selectCandle()');

        var newClass = '';

        if(this.state.fav === 'icon-heart5 text-pink icon-button swell')
            newClass = 'icon-heart6 text-pink icon-button swell2';
        else
            newClass = 'icon-heart5 text-pink icon-button swell';
        
        this.setState((prev, props) => {
            return {
                fav : newClass
            }
        });

        // Log event to GA
        GoogleAnalytics.newAction('Chart', 'Favourite', this.props.topic);
    }

    // Changes the chart type between candlestick and heikin ashi
    selectChartType = (type) => {
        this.props.onSelectChartType(type);
    }

    // Select an overlay and apply it to chart
    selectOverlay(overlay) {

        var status = !this.state.overlays[overlay];
        var ovs = this.state.overlays;

        ovs[overlay] = status;

        this.props.onSelectOverlay(overlay, status);

        this.setState((prev, props) => {
            return {
                overlays : ovs
            }
        });
    }

/**********************************************************
 *  Render
 **********************************************************/

    render() {

        //console.log('ChartDetails.render()');

        const quoteCurrency = this.props.topic.split("-")[2];
        const currencySymbol = CurrencyStore.getCurrencySymbol(quoteCurrency);

        const params = ChartStore.getAllParameters();
        const name = CurrencyStore.getCoinName(params.currency);
        const decimals = CurrencyStore.getFormat(params.quoteCurrency);

        return (

            <div className='details-holder'>

                <div className='details-panel'>

                    <div className="price-image">
                        <img src={'/assets/img/coins/' + params.currency + '.png'} className="img-circle img-sm" alt=""></img>
                    </div>

                    <div className="coin-name">{name}</div>
                    <div className="coin-ticker">({params.currency})</div>

                </div>

                <Transition timeout={1000} in={!!this.state.show}>
                {(status) => (

                    <div>

                    <div className="details-panel details-price">

                        <div className={`blinker blink-${status} chart-price-small`}>
                            <span className="price-symbol">{ currencySymbol }</span>{ Numeral(this.state.price).format(decimals) }
                        </div>
                    </div>

                    

                    <div className="details-panel badges">
                        <div className="details-badge">24hrs</div>
                        <div className={`blinker blink-${status} chart-price-small`}>
                            {/*<span className="label label-flat label-info" style={{marginRight:'10px'}}>24hrs</span>*/}
                            { Numeral(this.state.change).format(CurrencyStore.getCurrencyFormat()) }%     
                            <i className={this.state.change > 0 ? 'icon-arrow-up8 green-text left-pad arrow hover-up' : 'icon-arrow-down8 red-text left-pad arrow hover-down'}></i>
                        </div>

                    </div>

                    </div>

                )}
                </Transition>

                {/*<div className="details-panel badges">

                    <div className="details-badge purple">{params.quoteCurrency}</div>
                    <div className="details-badge blue">{params.exchange}</div>
            </div>*/}

            </div>

        );
        
    }
}

export default ChartDetails;





// WEBPACK FOOTER //
// ./src/Views/Charting/ChartDetails.js